import { render, staticRenderFns } from "./RefStatusesList.vue?vue&type=template&id=738dcdd4&scoped=true"
import script from "./RefStatusesList.vue?vue&type=script&lang=js"
export * from "./RefStatusesList.vue?vue&type=script&lang=js"
import style0 from "./RefStatusesList.vue?vue&type=style&index=0&id=738dcdd4&prod&lang=scss&scoped=true"
import style1 from "./RefStatusesList.vue?vue&type=style&index=1&id=738dcdd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738dcdd4",
  null
  
)

export default component.exports